import React from 'react'
import Index from "../feturebasedforecasting/Stage3FeatureLevelForecasting"

const Stage3FeatureLevelForecasting = ({ onBack, onNext }) => {
  return (
    <Index onBack={onBack} onNext={onNext} />
  )
}

export default Stage3FeatureLevelForecasting
